/**
 * «Образование» сотрудника — выпадающим списком, как на шаге «Заполнение данных» мастера обучения
 * (ответ заказчицы 04.11 к п.1.3): «Высшее», «Среднее профессиональное», «Нет»; пусто — «Не
 * указано». Значение, введённое раньше свободным текстом и не приведённое к списку, не теряется:
 * оно показывается отдельным пунктом «прежнее: …» и сохраняется, пока не выбрали другое.
 */
import { TRAINING_EDUCATION_OPTIONS, isTrainingEducationSelected } from '@/lib/training'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/design-system/components/primitives/select'

/** «Не указано» — у Radix Select нет пустого значения пункта. */
const NOT_SET = '__not_set__'

export function EducationSelect({
  id,
  value,
  onChange,
  disabled,
  ariaLabel = 'Образование',
}: {
  id?: string
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  ariaLabel?: string
}) {
  const legacy = value.trim() !== '' && !isTrainingEducationSelected(value) ? value : ''
  return (
    <Select
      value={value.trim() === '' ? NOT_SET : value}
      disabled={disabled}
      onValueChange={(v) => onChange(v === NOT_SET ? '' : v)}
    >
      <SelectTrigger id={id} aria-label={ariaLabel}>
        <span className="min-w-0 flex-1 truncate text-left">
          <SelectValue />
        </span>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NOT_SET}>Не указано</SelectItem>
        {TRAINING_EDUCATION_OPTIONS.map((opt) => (
          <SelectItem key={opt} value={opt}>
            {opt}
          </SelectItem>
        ))}
        {legacy ? <SelectItem value={legacy}>прежнее: {legacy}</SelectItem> : null}
      </SelectContent>
    </Select>
  )
}
